export default [
  {
    name: 'Society of lifestyle',
    type: 'society_of_lifestyle',
    syncs: true,
    sync_interval: 'daily',
    sync_time: '01:00'
  },
  {
    name: 'Present time',
    type: 'present_time',
    syncs: false,
    sync_interval: 'none'
  },
  {
    name: 'De eekhoorn',
    type: 'de_eekhoorn',
    syncs: true,
    sync_interval: 'daily',
    sync_time: '20:00'
  }
]



// WEBPACK FOOTER //
// ./src/dropshipment/vendors.js